import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form } from 'antd'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return <Form {...formProps} form={form} layout="vertical"></Form>
}

export default Create
